import { render } from "./TrustedBy.vue?vue&type=template&id=3fbddc00&scoped=true"
import script from "./TrustedBy.vue?vue&type=script&lang=js"
export * from "./TrustedBy.vue?vue&type=script&lang=js"

import "./TrustedBy.vue?vue&type=style&index=0&id=3fbddc00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbddc00"]])

export default __exports__